import {
  buildDefaultRowInstructionDescriptor,
  buildSheetStrategyInstructionDescriptor,
  buildShortRowInstructionDescriptor,
} from "../messages/exportMessages.js";
import { getEffectiveSheetStrategy } from "./strategies";
import { assessStripLayout } from "./stripLayout";
import { getSheetSize } from "../domain/sheetSize";

export function getSheetStrategyInstruction(strategy, sheet, sourcePanel, exportDraft) {
  return buildSheetStrategyInstructionDescriptor(strategy, sheet, sourcePanel, exportDraft);
}

export function getDefaultRowInstruction(row, exportDraft) {
  return buildDefaultRowInstructionDescriptor(row, exportDraft);
}

export function getShortRowInstruction(row, exportDraft, exportRow = {}) {
  return buildShortRowInstructionDescriptor(row, exportDraft, exportRow);
}

export function getStripDeliveryRows(layout, sourcePanel, exportDraft) {
  const rows = [];

  layout.sheets.forEach((sheet) => {
    const strategy = getEffectiveSheetStrategy(exportDraft, sheet.index);
    if (strategy !== "strips") return;
    if (!assessStripLayout(sheet, sourcePanel).eligible) return;

    const widthCounts = sheet.placements.reduce((result, placement) => {
      const key = Math.round(placement.width);
      result[key] = (result[key] || 0) + 1;
      return result;
    }, {});

    sheet.placements.forEach((placement) => {
      const repeatedWidth = widthCounts[Math.round(placement.width)] > 1;
      const stripLength = repeatedWidth ? Number(sourcePanel.length || 2440) : Math.round(placement.length);
      const stripWidth = repeatedWidth ? Math.round(placement.width) : Number(sourcePanel.width || 1220);
      const restLength = Math.max(stripLength - Math.round(placement.length), 0);
      const restWidth = Math.max(stripWidth - Math.round(placement.width), 0);

      rows.push({
        sheetNumber: sheet.index + 1,
        thickness: sheet.thickness,
        name: placement.name,
        stripSize: `${Math.round(stripLength)} × ${Math.round(stripWidth)} mm`,
        finalSize: `${Math.round(placement.originalLength)} × ${Math.round(placement.originalWidth)} mm`,
        selfCut: restLength > 0
          ? `${Math.round(restLength)} × ${Math.round(stripWidth)} mm`
          : restWidth > 0
            ? `${Math.round(stripLength)} × ${Math.round(restWidth)} mm`
            : { key: "core.stripDelivery.notApplicable" },
      });
    });
  });

  return rows;
}

export function summarizeRepeatedSizes(rows, keyName) {
  const counts = rows.reduce((result, row) => {
    const key = typeof row[keyName] === "string"
      ? row[keyName]
      : String(row[keyName]?.key || "");
    result[key] = (result[key] || 0) + 1;
    return result;
  }, {});

  return Object.entries(counts)
    .map(([size, count]) => `${count}× ${size}`)
    .join(", ");
}

export function getSheetPrintHeading(sheet, sourcePanel, exportDraft, strategy) {
  const { length, width } = getSheetSize(sheet, sourcePanel);
  return {
    thickness: sheet.thickness,
    length,
    width,
    strategy,
    exportDraft,
    sheet,
    sourcePanel,
  };
}

export function getSheetPrintSummary(sheet, sourcePanel, exportDraft, strategy, displayOffcuts) {
  return {
    sheet,
    sourcePanel,
    exportDraft,
    strategy,
    displayOffcuts,
  };
}
